module.exports = __webpack_public_path__ + "img/abBanner-id.d7df9c95.png";